import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { GLOBAL_COMPLIANCE_CHECKLIST } from '../../utils/constants';
import { Globe, Shield, FileText, ExternalLink } from 'lucide-react';
export function Global() {
  return <Layout data-id="element-1711">
      <div className="container mx-auto px-4 py-12" data-id="element-1712">
        <div className="mb-12" data-id="element-1713">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-1714">
            <Globe className="h-3 w-3 mr-2" data-id="element-1715" />
            Compliance / Global
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-1716">
            Global Standards Alignment
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-1717">
            Cybersecurity framework based on international standards (NIST, ISO,
            CIS).
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1718">
          <div className="lg:col-span-2 space-y-12" data-id="element-1719">
            <section data-id="element-1720">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1721">
                <Shield className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1722" />
                Primary Reference Standards
              </h2>
              <div className="space-y-4" data-id="element-1723">
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1724">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1725">
                    NIST Cybersecurity Framework 2.0
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1726">
                    Gold standard for organizational cyber risk management.
                    Focus on functions: Govern, Identify, Protect, Detect,
                    Respond, Recover.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1727">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1728">
                    ISO/IEC 27001:2022
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1729">
                    International standard for Information Security Management
                    Systems (ISMS). Focus on processes, policies, and controls.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1730">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1731">
                    CIS Controls v8
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1732">
                    Prioritized list of effective technical defense actions to
                    block cyber attacks.
                  </p>
                </Card>
              </div>
            </section>

            <section data-id="element-1733">
              <h2 className="text-2xl font-bold text-slate-100 mb-6" data-id="element-1734">
                NIST CSF 2.0 Core Functions
              </h2>
              <div className="grid md:grid-cols-2 gap-4" data-id="element-1735">
                <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800" data-id="element-1736">
                  <h3 className="font-bold text-cyan-400 mb-1" data-id="element-1737">GOVERN</h3>
                  <p className="text-sm text-slate-400" data-id="element-1738">
                    Establish context, policies, and oversight.
                  </p>
                </div>
                <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800" data-id="element-1739">
                  <h3 className="font-bold text-cyan-400 mb-1" data-id="element-1740">IDENTIFY</h3>
                  <p className="text-sm text-slate-400" data-id="element-1741">
                    Asset management & risk assessment.
                  </p>
                </div>
                <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800" data-id="element-1742">
                  <h3 className="font-bold text-cyan-400 mb-1" data-id="element-1743">PROTECT</h3>
                  <p className="text-sm text-slate-400" data-id="element-1744">
                    Access control, data security, training.
                  </p>
                </div>
                <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800" data-id="element-1745">
                  <h3 className="font-bold text-cyan-400 mb-1" data-id="element-1746">DETECT</h3>
                  <p className="text-sm text-slate-400" data-id="element-1747">
                    Monitoring & anomaly detection.
                  </p>
                </div>
                <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800" data-id="element-1748">
                  <h3 className="font-bold text-cyan-400 mb-1" data-id="element-1749">RESPOND</h3>
                  <p className="text-sm text-slate-400" data-id="element-1750">
                    Incident response & communications.
                  </p>
                </div>
                <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-800" data-id="element-1751">
                  <h3 className="font-bold text-cyan-400 mb-1" data-id="element-1752">RECOVER</h3>
                  <p className="text-sm text-slate-400" data-id="element-1753">
                    Recovery planning & improvements.
                  </p>
                </div>
              </div>
            </section>
          </div>

          <div className="space-y-6" data-id="element-1754">
            <Checklist id="global-compliance" title="Implementation Checklist" items={GLOBAL_COMPLIANCE_CHECKLIST} data-id="element-1755" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-1756">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-1757">
                Official Resources
              </h3>
              <div className="space-y-3" data-id="element-1758">
                <a href="https://www.nist.gov/cyberframework" target="_blank" rel="noopener noreferrer" data-id="element-1759">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-1760">
                    NIST CSF Website
                    <ExternalLink className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-1761" />
                  </Button>
                </a>
                <a href="https://www.cisecurity.org/controls" target="_blank" rel="noopener noreferrer" data-id="element-1762">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-1763">
                    CIS Controls
                    <ExternalLink className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-1764" />
                  </Button>
                </a>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}